import './PanelTextInput.css';

const PanelTextInput = ({ value, callbackOnChange, callbackOnKeyDown, placeholder, maxLength }) => (
  <input
    type="text"
    className="panel-text-input"
    value={value}
    onChange={callbackOnChange}
    onKeyDown={callbackOnKeyDown}
    placeholder={placeholder}
    maxLength={maxLength}
  />
);

export { PanelTextInput };
